import {Injectable} from '@angular/core';
import {API_ENDPOINT, API_HTTP_REQUEST_TIMEOUT, API_TOKEN_NAME, API_PLATFORM, SESSION_ID_NAME, API_PLATFORM_SYSTEM} from '../../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {timeout} from 'rxjs/operators';
import {ErrorService} from '../error-service/error.service';
import {Platform} from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    
    constructor(private httpClient: HttpClient,
                private errorService: ErrorService,
                private platform: Platform) {
    }
    
    /**
     * User Login
     * @param accountData: object
     */
    login(accountData: object): Observable<any> {
        
        const url = API_ENDPOINT + 'login';
        return this.httpClient
            .post(url, accountData, {headers: {}, responseType: 'json', reportProgress: true, observe: 'response'})
            .pipe(
                timeout(API_HTTP_REQUEST_TIMEOUT)
            );
    }
    
    /**
     * Request to API
     * @param route: string
     * @param token: string
     */
    getData(route: string, token: string, sessionId: string): Observable<any> {
        const url = API_ENDPOINT + route;
        const isApp = !(this.platform.is('mobileweb') || this.platform.is('desktop'));
        const platform_system = this.platform.is('ios');
        const headers = new HttpHeaders()
            .set(API_TOKEN_NAME, token)
            .set(API_PLATFORM, isApp ? 'true' : 'false')
            .set(API_PLATFORM_SYSTEM, platform_system ? 'iOS' : 'Android')
            .set(SESSION_ID_NAME, sessionId);
        this.errorService.consoleLog('ApiService:getData', 'getDataURL:', {url: url});
        return this.httpClient
            .get(url, {headers: headers, responseType: 'json', observe: 'response'})
            .pipe(
                timeout(API_HTTP_REQUEST_TIMEOUT)
            );
    }
    
    /**
     * Request to API
     * @param route: string
     * @param token: string
     */
    getDataText(route: string, token: string, sessionId: string): Observable<any> {
        const url = API_ENDPOINT + route;
        this.errorService.consoleLog('ApiService:getDataText', 'getDataURL', url);
        const isApp = !(this.platform.is('mobileweb') || this.platform.is('desktop'));
        const platform_system = this.platform.is('ios');
        const headers = new HttpHeaders()
            .set(API_TOKEN_NAME, token)
            .set(API_PLATFORM, isApp ? 'true' : 'false')
            .set(API_PLATFORM_SYSTEM, platform_system ? 'iOS' : 'Android')
            .set(SESSION_ID_NAME, sessionId);
        return this.httpClient
            .get(url, {headers: headers, responseType: 'text', observe: 'response'})
            .pipe(
                timeout(API_HTTP_REQUEST_TIMEOUT)
            );
    }
    
    /**
     * send Data from Formular
     * @param route
     * @param token
     * @param formdata
     */
    sendFormData(route: string, token: string, formdata: any, sessionId: string): Observable<any> {
        const url = API_ENDPOINT + route;
        const isApp = !(this.platform.is('mobileweb') || this.platform.is('desktop'));
        const platform_system = this.platform.is('ios');
        const headers = new HttpHeaders()
            .set(API_TOKEN_NAME, token)
            .set(API_PLATFORM, isApp ? 'true' : 'false')
            .set(API_PLATFORM_SYSTEM, platform_system ? 'iOS' : 'Android')
            .set(SESSION_ID_NAME, sessionId);
        this.errorService.consoleLog('ApiService:sendFormData', 'sendFormData url', url);
        return this.httpClient
            .post(url, formdata, {headers: headers, responseType: 'json', observe: 'response'})
            .pipe(
                timeout(API_HTTP_REQUEST_TIMEOUT)
            );
    }
    
    // getProductsList(): Observable<any> {
    //     return this.httpClient
    //         .get('http://192.168.0.227:8082/regisafe/json/sympto.products.json', {headers: {}, responseType: 'json', observe: 'response'}).pipe(
    //             timeout(API_HTTP_REQUEST_TIMEOUT)
    //         );
    // }
    
    getProductsListLocal(): Observable<any> {
        return this.httpClient
            .get('assets/sympto.products.json', {headers: {}, responseType: 'json', observe: 'response'}).pipe(
                timeout(API_HTTP_REQUEST_TIMEOUT)
            );
    }
    
    // sendMessageWithImage(route: string, token: string, formdata: any): Observable<any> {
    //     const url = API_ENDPOINT + route;
    //     const headers = new HttpHeaders().set(API_TOKEN_NAME, token);
    //     console.log('sendMessageWithImage url: ', url);
    //     return this.httpClient
    //         .post(url, formdata, {headers: {}, responseType: 'json', observe: 'response'}).pipe(
    //             timeout(API_HTTP_REQUEST_TIMEOUT)
    //         );
    // }

    validatePurchaseAgainstServer(purchase): Observable<any> {
        const body = {
            data: purchase
        };
        console.log('### validatePurchaseAgainstServer: ', body);
        return this.httpClient
            .post('http://192.168.0.45/iap_validator/', body, {headers: {}, responseType: 'text', observe: 'response'})
            .pipe(
                timeout(API_HTTP_REQUEST_TIMEOUT)
            );
    }
}
